import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "double-select mr-2" }
const _hoisted_2 = { class: "input-wrapper input-slim" }
const _hoisted_3 = { class: "uppercase text-raleway-13" }

import VatComponent from "@/components/vatComponent/vatComponent.vue";



export default /*#__PURE__*/_defineComponent({
  __name: 'vatNumberComponent',
  props: {
    buyer_vat: {},
    buyer_vat_start: {},
    initialValues: {},
    errors: {}
  },
  setup(__props: any) {

const props = __props;



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.$tc("Vat number")), 1),
      _createVNode(VatComponent, {
        tabindex: 7,
        class: _normalizeClass({ 'error-vat error-input': !!_ctx.errors }),
        value: props?.buyer_vat || '',
        placeholder: '###-###-##',
        name: 'buyer_vat',
        start: props.buyer_vat_start,
        change: 'changeStartValue_vat_phone_start'
      }, null, 8, ["class", "value", "start"])
    ])
  ]))
}
}

})